/* production build : npm run build */
//const profiles = "dev"
//const profiles = "test"
const profiles = "prod"
const VERSION_NUMBER = "1.0.25";

//export const isDevBuild = false //false == Production, 
const isDeployedNginxLocal = false //false == dev on npm,
// 프로필에 따른 접미사 정의
const getSuffix = (profile) => {
    switch (profile) {
        case "dev": return "-SNAPSHOT";
        case "test": return "-RC";
        case "prod": return "-RELEASE";
        default: return "-RELEASE";
    }
};

export const MODE_VERSION = `${VERSION_NUMBER}${getSuffix(profiles)}`;

//host Server url
const SERVER_URL_DEV = "http://localhost:8889"
const SERVER_URL_TEST = "https://www.gkoosoft.co.kr"
const SERVER_URL_PROD = "https://www.g-worker.co.kr"

//server fileUpload url
const SERVER_URL_FILE_UPLOAD_DEV = SERVER_URL_DEV + '/gkoosoft-job-backend'
const SERVER_URL_FILE_UPLOAD_TEST = SERVER_URL_TEST + '/gkoosoft-job-backend'
const SERVER_URL_FILE_UPLOAD_PROD = "http://germanwork.cafe24.com" + '/gkoosoft-job-backend'

//file server - nginx
const FILE_SERVER_URL_DEV = "http://localhost:3001"
const FILE_SERVER_URL_TEST = SERVER_URL_TEST
const FILE_SERVER_URL_PROD = SERVER_URL_PROD

//backend tomcat url
const BACKEND_URL_DEV = SERVER_URL_DEV + '/gkoosoft-job-backend'
const BACKEND_URL_TEST = SERVER_URL_TEST + '/gkoosoft-job-backend'
const BACKEND_URL_PROD = SERVER_URL_PROD + '/gkoosoft-job-backend'

//export const BACKEND_URL = isDevBuild ? BACKEND_URL_DEV : BACKEND_URL_PROD
export const BACKEND_URL = profiles == "dev" ? BACKEND_URL_DEV : profiles == "test" ? BACKEND_URL_TEST : BACKEND_URL_PROD

//export const BACKEND_FILE_UPLOAD_URL = isDevBuild ? SERVER_URL_FILE_UPLOAD_DEV : SERVER_URL_FILE_UPLOAD_PROD
export const BACKEND_FILE_UPLOAD_URL = profiles == "dev" ? SERVER_URL_FILE_UPLOAD_DEV : profiles == "test" ? SERVER_URL_FILE_UPLOAD_TEST : SERVER_URL_FILE_UPLOAD_PROD

//Frontend url - DEV node in local 3000, frontend deployed in nginx server in local 3001
const INITIAL_PAGE_URL_DEV = isDeployedNginxLocal ? 'http://localhost:3001/' : 'http://localhost:3000/'
const INITIAL_PAGE_URL_TEST = SERVER_URL_TEST + '/'
const INITIAL_PAGE_URL_PROD = SERVER_URL_PROD + '/'

export const INITIAL_PAGE_URL = profiles == "dev" ? INITIAL_PAGE_URL_DEV : profiles == "test" ? INITIAL_PAGE_URL_TEST : INITIAL_PAGE_URL_PROD

//TODO: IMAGE -> FILE
//npm use the port number 3000
//local dev with npm and it needs to serve files -> start nginx server
const IMAGE_URL_DEV = FILE_SERVER_URL_DEV + '/files/'
const IMAGE_URL_TEST = FILE_SERVER_URL_TEST + '/files/'
const IMAGE_URL_PROD = FILE_SERVER_URL_PROD + '/files/'

export const IMAGE_URL_PREFIX = profiles == "dev" ? IMAGE_URL_DEV : profiles == "test" ? IMAGE_URL_TEST : IMAGE_URL_PROD

const LOGO_URL_DEV = FILE_SERVER_URL_DEV + '/logos/'
const LOGO_URL_TEST = FILE_SERVER_URL_TEST + '/logos/'
const LOGO_URL_PROD = FILE_SERVER_URL_PROD + '/logos/'

export const LOGO_URL_PREFIX = profiles == "dev" ? LOGO_URL_DEV : profiles == "test" ? LOGO_URL_TEST : LOGO_URL_PROD

const NEWS_URL_DEV = FILE_SERVER_URL_DEV + '/images/news/'
const NEWS_URL_TEST = FILE_SERVER_URL_TEST + '/images/news/'
const NEWS_URL_PROD = FILE_SERVER_URL_PROD + '/images/news/'

export const NEWS_URL_PREFIX = profiles == "dev" ? NEWS_URL_DEV : profiles == "test" ? NEWS_URL_TEST : NEWS_URL_PROD

//3MB
export const MAX_PDF_FILE_SIZE = 30000000

//구글 소셜 로그인
const GOOGLE_CLIENT_ID_DEV = "198058475744-drfnspbkchiscva63b763e45ip02gok1.apps.googleusercontent.com"
const GOOGLE_CLIENT_ID_TEST = "198058475744-eo2bqs0apaajf1e8p1223i1l81ukjbh8.apps.googleusercontent.com"
const GOOGLE_CLIENT_ID_PROD = "198058475744-rpqsa36u60c7hblkpmto2asph45uufbl.apps.googleusercontent.com"

export const GOOGLE_CLIENT_ID = profiles == "dev" ? GOOGLE_CLIENT_ID_DEV : profiles == "test" ? GOOGLE_CLIENT_ID_TEST : GOOGLE_CLIENT_ID_PROD

//코리아타운 이미지 URL, dev는 test 환경 사용하기
const KOREATOWN_URL_DEV =  FILE_SERVER_URL_TEST + '/koreatown/logos/'
const KOREATOWN_URL_TEST = FILE_SERVER_URL_TEST + '/koreatown/logos/'
const KOREATOWN_URL_PROD = FILE_SERVER_URL_PROD + '/koreatown/logos/'

export const KOREATOWN_LOGO_URL_PREFIX = profiles == "dev" ? KOREATOWN_URL_DEV : profiles == "test" ? KOREATOWN_URL_TEST : KOREATOWN_URL_PROD

//한인 전문가 이미지 URL, dev는 test 환경 사용하기
const TALENT_URL_DEV =  FILE_SERVER_URL_TEST + '/talent/'
const TALENT_URL_TEST = FILE_SERVER_URL_TEST + '/talent/'
const TALENT_URL_PROD = FILE_SERVER_URL_PROD + '/talent/'

export const TALENT_IMAGE_URL_PREFIX = profiles == "dev" ? TALENT_URL_DEV : profiles == "test" ? TALENT_URL_TEST : TALENT_URL_PROD

//google analytics
export const isPROD = profiles == "prod" ? true : false
